import { camelize } from './string';

const msPattern = /^-ms-/;


/**
 * 将样式名称转换为驼峰命名法格式
 * 
 * 此函数用于将CSS样式名称从短横线命名法转换为驼峰命名法，以适应JavaScript的命名习惯
 * 它首先通过替换函数内部定义的正则表达式`msPattern`中的内容，将样式名称中的`ms-`前缀处理掉
 * 然后使用`camelize`函数将处理后的字符串转换为驼峰命名法
 * 
 * @param name {string} 需要转换的样式名称，可以包含短横线
 * @returns {string} 转换为驼峰命名法后的样式名称
 */
export const camelizeStyleName = (name: string) => {
  return camelize(name.replace(msPattern, 'ms-'));
}
